module.exports = __webpack_public_path__ + "static/media/jalapeno-lime-mobile-en.6ce2048a.jpg";